import React, { useState } from 'react';
import { PageSidebar, PageId } from '../components/library/PageSidebar';
import { TopBar } from '../components/library/TopBar';
import { ReadmePage } from '../components/library/pages/ReadmePage';
import { BrandDossierPage } from '../components/library/pages/BrandDossierPage';
import { FeedTemplatesPage } from '../components/library/pages/FeedTemplatesPage';
import { StoriesTemplatesPage } from '../components/library/pages/StoriesTemplatesPage';
import { PrintOfflinePage } from '../components/library/pages/PrintOfflinePage';
import { AdVariantsPage } from '../components/library/pages/AdVariantsPage';
import { MasterExportPage } from '../components/library/pages/MasterExportPage';
const pageTitles: Record<PageId, string> = {
  readme: '00_README',
  dossier: '01_BRAND_DOSSIER',
  feed: '02_TEMPLATES_FEED',
  stories: '03_TEMPLATES_STORIES',
  print: '04_TEMPLATES_PRINT_OFFLINE',
  ads: '05_AD_VARIANTS',
  master: '06_MASTER_EXPORT'
};
export function TemplateLibrary() {
  const [activePage, setActivePage] = useState<PageId>('readme');
  return <div className="min-h-screen flex bg-film-cream font-sans" data-id="element-1861">
      <PageSidebar active={activePage} onSelect={setActivePage} data-id="element-1862" />
      <div className="flex-1 min-w-0 flex flex-col" data-id="element-1863">
        <TopBar pageTitle={pageTitles[activePage]} data-id="element-1864" />
        {/* Canvas with dot grid */}
        <main className="flex-1 overflow-y-auto" style={{
        backgroundImage: 'radial-gradient(circle, #E8E8E8 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} data-id="element-1865">
          {activePage === 'readme' && <ReadmePage data-id="element-1866" />}
          {activePage === 'dossier' && <BrandDossierPage data-id="element-1867" />}
          {activePage === 'feed' && <FeedTemplatesPage data-id="element-1868" />}
          {activePage === 'stories' && <StoriesTemplatesPage data-id="element-1869" />}
          {activePage === 'print' && <PrintOfflinePage data-id="element-1870" />}
          {activePage === 'ads' && <AdVariantsPage data-id="element-1871" />}
          {activePage === 'master' && <MasterExportPage data-id="element-1872" />}
        </main>
      </div>
    </div>;
}